import React from 'react';
import ReactCardFlip from 'react-card-flip';
import { SymbolTileData } from 'widgets/symbolTile/components/symbolTileData';
import { SymbolTileChart } from 'widgets/symbolTile/components/chart/SymbolTileChart';
import { SymbolTileValues } from 'widgets/symbolTile/components/values/SymbolTileValues';
import { SymbolTileConfigState } from 'widgets/symbolTile/store/instances/config/SymbolTileConfigState';

interface SymbolTileContentProps {
    data?: SymbolTileData;
    config: SymbolTileConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<SymbolTileConfigState>
    ) => void;
}

export function SymbolTileContent(props: SymbolTileContentProps) {
    const { data, config, dispatchConfigChanged } = props;

    const { view } = config;

    const isFlipped = view === 'values';

    const flip = () => {
        const nextView = isFlipped ? 'chart' : 'values';
        dispatchConfigChanged({ view: nextView });
    };

    if (!data) {
        return <div className="SymbolTileContent">No data</div>;
    }

    return (
        <div className="SymbolTileContent" onClick={flip}>
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <SymbolTileChart key="front" data={data} />
                <SymbolTileValues key="back" data={data} />
            </ReactCardFlip>
        </div>
    );
}
